<template>
  <div class="d-flex flex-column gap-3" id="impresionPdf">
    <div class="d-flex gap-2" data-html2canvas-ignore="true">
      <div class="d-flex justify-content-center gap-2 w-100">
        <!-- <button type="button" class="btn btn-sm btn-primary" @click="descargar">
          <i class="bi bi-file-earmark-arrow-down me-1"></i>
          Descargar Documento
        </button> -->
        <button
          type="button"
          class="btn btn-sm btn-primary"
          @click="descargar"
          :disabled="descargandoDocumento"
        >
          <span
            v-if="descargandoDocumento"
            class="spinner-border spinner-border-sm me-1"
            role="status"
            aria-hidden="true"
          ></span>

          <i v-else class="bi bi-file-earmark-arrow-down me-1"></i>

          {{ descargandoDocumento ? "Descargando..." : "Descargar Documento" }}
        </button>
        <button
          v-if="ticket.tipoEnvio == 'CON_ADJUNTOS'"
          type="button"
          class="btn btn-sm btn-primary"
          @click="toggleAdjuntos"
        >
          <i class="bi bi-file-earmark-arrow-down me-1"></i>
          Ir a Sección Adjuntos
        </button>
        <button
          type="button"
          class="btn btn-sm btn-primary"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Responder documento"
          @click="responder()"
          v-if="buzon == 'Recibidos'"
        >
          <i class="bi bi-file-earmark-plus me-1"></i>
          Responder
        </button>
      </div>
      <!-- <button
        type="button"
        class="btn btn-sm btn-primary"
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title="Descargar Detalle"
        @click="descargarPdfDetalle()"
      >
        <i class="bi bi-filetype-pdf"></i>
      </button> -->
      <button
        type="button"
        class="btn btn-sm btn-primary"
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title="Descargar Detalle"
        @click="descargarPdfDetalle()"
        :disabled="descargandoDetalle"
      >
        <span
          v-if="descargandoDetalle"
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>

        <i v-else class="bi bi-filetype-pdf"></i>
      </button>
    </div>

    <div class="card">
      <div class="card-header fw-semibold">Datos generales</div>

      <div class="card-body">
        <div class="d-flex flex-column rounded px-3 gap-1">
          <div
            class="d-flex align-items-center justify-content-between fw-semibold"
          >
            <div
              class="d-flex align-items-center justify-content-between small spacing"
              v-if="descripcionEstadoConfirmacion"
            >
              <span
                class="badge"
                :style="{ backgroundColor: colorEstadoConfirmacion }"
              >
                {{ descripcionEstadoConfirmacion }} el {{ fechaLeida }}
              </span>
            </div>
            <div class="d-flex">
              <div v-if="!etiquetasLocal.length">
                <button
                  v-if="this.showEtiquetas"
                  data-html2canvas-ignore="true"
                  type="button"
                  class="btn btn-sm btn-success"
                  title="Agregar Etiqueta"
                  @click="agregarEtiqueta()"
                >
                  <i class="bi bi-file-earmark-plus me-1"></i>
                  Agregar Etiqueta
                </button>
              </div>
              <div v-else style="text-align: end">
                <div
                  v-for="(tag, id) in etiquetasLocal"
                  :key="id"
                  class="badge badge-pill ms-2"
                  :style="{
                    backgroundColor: tag.color,
                    cursor: 'pointer',
                    minWidth: '3em',
                  }"
                  @click="agregarEtiqueta"
                >
                  <span>{{ mostrar(tag.nombre) }}</span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <span class="d-inline-block w-50 fw-bold">Causa</span>
            <span class="d-inline-block text-muted w-50 text-end"
              >Enviado el {{ formatear(ticket.timeStamp) }}</span
            >
          </div>
          <div class="d-flex align-items-center justify-content-between small">
            <span class="d-inline-block" style="width: 20%">{{
              mostrar(ticket.causaOrigen.numero)
            }}</span>
            <span class="d-inline-block" style="width: 80%">{{
              mostrar(ticket.causaOrigen.caratula)
            }}</span>
          </div>
          <div
            class="d-flex align-items-center justify-content-between fw-semibold"
          >
            <span class="d-inline-block w-50">Origen</span>
            <span class="d-inline-block w-50 text-start">Destino</span>
          </div>
          <div class="d-flex align-items-center justify-content-between small">
            <span class="d-inline-block text-truncate w-50">{{
              mostrar(ticket.causaOrigen.dependencia.nombreOrganismo)
            }}</span>
            <span class="d-inline-block text-truncate w-50 text-start">{{
              mostrar(ticket.causaDestino.dependencia.nombreOrganismo)
            }}</span>
          </div>
          <div class="d-flex align-items-center justify-content-between small">
            <span class="d-inline-block text-truncate w-50">{{
              mostrar(ticket.causaOrigen.dependencia.nombreDependencia)
            }}</span>
            <span class="d-inline-block text-truncate w-50 text-start">{{
              mostrar(ticket.causaDestino.dependencia.nombreDependencia)
            }}</span>
          </div>

          <div
            class="d-flex align-items-center justify-content-between"
            v-if="
              this.ticket.observaciones !== null &&
              this.ticket.observaciones !== undefined &&
              this.ticket.observaciones !== ''
            "
          >
            <span class="d-inline-block">Observaciones</span>

            <div
              class="d-flex align-items-center justify-content-between small"
            >
              <span class="d-inline-block">{{ mostrar(ticket.observaciones) }}</span>
            </div>
          </div>

          <div class="d-flex align-items-center justify-content-between small">
            <span
              class="badge bg-danger"
              v-if="ticket.estadoOperacion == 'RECHAZADO'"
            >
              {{ capitalize(ticket.estadoOperacion) }}
              <!-- Rechazado -->
            </span>
          </div>
          <div
            class="d-flex align-items-center justify-content-between small spacing"
          >
            <span
              v-if="ticket.estadoOperacion == 'RECHAZADO'"
              class="msgRechazado"
              >{{ mostrar(ticket.motivoEstado) }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <!-- BFA -->
    <div
      class="accordion"
      id="accordionExample2"
      v-if="
        ticket.regBFA.whostamped ||
        ticket.regBFA.blocknumber ||
        ticket.regBFA.blocktimestamp
      "
    >
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingOne">
          <button
            class="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseBFA"
            aria-expanded="false"
            aria-controls="collapseBFA"
          >
            <span class="fw-semibold">Registros BFA</span>
          </button>
        </h2>
        <div
          id="collapseBFA"
          class="accordion-collapse collapse"
          aria-labelledby="headingOne"
        >
          <div class="accordion-body p-3">
            <!--      <div
              class="d-flex align-items-center text-truncate justify-content-between"
            >
              <span class="d-inline-block fw-semibold">Whostamped</span>
              <span class="d-inline-block">{{ ticket.regBFA.whostamped }}</span>
            </div> -->
            <div class="d-flex align-items-center justify-content-between">
              <span class="d-inline-block fw-semibold">Blocknumber</span>
              <span class="d-inline-block">{{
                mostrar(ticket.regBFA.blocknumber)
              }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <span class="d-inline-block fw-semibold">Blocktimestamp</span>
              <span class="d-inline-block">{{
                mostrar(ticket.regBFA.blocktimestamp)
              }}</span>
            </div>
            <div
              class="d-flex align-items-center text-truncate justify-content-between"
              data-html2canvas-ignore="true"
              v-if="
                ticket.hash &&
                ticket.regBFA.whostamped &&
                ticket.regBFA.whostamped.length < 50
              "
            >
              <a
                :href="`https://bfa.ar/sello2#/hash/${ticket.hash}`"
                target="_blank"
                >{{ `https://bfa.ar/sello2#/hash/${ticket.hash}` }}</a
              >
            </div>
            <div
              class="d-flex align-items-center text-break justify-content-between"
              v-if="
                ticket.regBFA.whostamped &&
                ticket.regBFA.whostamped.length >= 50
              "
            >
              <button
                v-if="ticket.hash && ticket.regBFA.whostamped && !validacionBFA"
                type="button"
                class="btn btn-sm btn-primary mt-2"
                @click="validate(ticket.hash, ticket.regBFA.whostamped)"
              >
                Validar
              </button>
              <span
                v-if="validacionBFA && validacionBFA.status === 'success'"
                class="mt-2 text-success"
                >{{ mostrar(validacionBFA.messages) }}</span
              >
              <span
                v-if="validacionBFA && validacionBFA.status === 'failure'"
                class="mt-2 text-danger"
                >{{ mostrar(validacionBFA.messages) }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- CIERRE BFA -->
    <div class="accordion" id="accordionExample1">
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingOne">
          <button
            class="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseTran"
            aria-expanded="false"
            aria-controls="collapseTran"
          >
            <span class="fw-semibold">Movimientos</span>
          </button>
        </h2>

        <div
          id="collapseTran"
          class="accordion-collapse collapse"
          aria-labelledby="headingOne"
        >
          <div class="accordion-body p-3">
            <div class="rounded border overflow-hidden">
              <table class="table table-borderless align-middle m-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col">Mensaje</th>
                    <th scope="col">Tipo</th>
                    <th scope="col">Fecha</th>
                  </tr>
                </thead>

                <tbody class="border-top-0">
                  <tr
                    class="border-top"
                    v-for="(d, i) in ticket.transacciones"
                    :key="`transaccion-${i}`"
                  >
                    <td scope="row" data-label="#">
                      <span v-if="d.codigoMensaje == 'DOCUMENTO_ENVIADO'">
                        Registro de documento nuevo
                      </span>
                      <span v-if="d.codigoMensaje == 'ENTREGA_BROKER'">
                        Validación de políticas de seguridad
                      </span>
                      <span v-if="d.codigoMensaje == 'ENTREGA_DESTINO'">
                        Documento disponible para entrega
                      </span>
                      <span v-if="d.codigoMensaje == 'RECHAZA_BROKER'">
                        Documento rechazado
                      </span>
                    </td>
                    <td scope="row" data-label="Asunto">
                      {{ mostrar(d.tipoMensaje) }}
                    </td>
                    <td scope="row" data-label="Asunto">
                      {{ timeStamp(d.timeStamp) }}
                    </td>
                  </tr>
                  <tr
                    class="border-top"
                    v-for="(d, i) in ticket.trackings"
                    :key="`tracking-${i}`"
                  >
                    <td scope="row" data-label="#">
                      {{ mostrar(d.nombreEvento)
                      }}<span v-if="d.nombreEvento && d.detalleEvento"> - </span
                      >{{ mostrar(d.detalleEvento) }}
                    </td>
                    <td scope="row" data-label="Asunto">SEGUIMIENTO</td>
                    <td scope="row" data-label="Asunto">
                      {{ timeStamp(d.fecha) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="accordion"
      ref="adjuntosAcordeon"
      id="accordionExample3"
      v-if="ticket.tipoEnvio == 'CON_ADJUNTOS'"
    >
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingOne">
          <button
            class="accordion-button"
            :class="{ collapsed: !isAdjuntosOpen }"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseAdj"
            aria-expanded="isAdjuntosOpen"
            aria-controls="collapseAdj"
            @click="handleAccordionClick"
          >
            <span class="fw-semibold">Adjuntos</span>
          </button>
        </h2>

        <div
          id="collapseAdj"
          class="accordion-collapse collapse"
          :class="{ show: isAdjuntosOpen }"
          aria-labelledby="headingOne"
        >
          <p
            v-if="cargandoAdjuntos"
            class="text-muted fw-semibold mt-3 mb-3 text-center"
            role="status"
            aria-live="polite"
          >
            <span
              class="spinner-border spinner-border-sm me-2"
              aria-hidden="true"
            ></span>
            Cargando adjuntos...
          </p>
          <p
            v-else-if="documento && documento.data && documento.data.adjuntos"
            class="text-muted fw-semibold mt-1 ms-3 mb-0"
            data-html2canvas-ignore="true"
            style="font-size: 13px"
          >
            Descargue los adjuntos de manera individual desde el ícono de
            descarga.
          </p>
          <div
            v-if="documento && documento.data && documento.data.adjuntos"
            class="accordion-body p-3 pt-2"
          >
            <div class="rounded border overflow-hidden">
              <table class="table table-borderless align-middle m-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col">Archivo</th>
                    <th scope="col">Tipo</th>
                  </tr>
                </thead>

                <tbody class="border-top-0">
                  <tr
                    class="border-top"
                    v-for="(d, i) in this.documento.data.adjuntos"
                    :key="i"
                  >
                    <td scope="row" data-label="Descargar">
                      <button
                        type="button"
                        class="btn btn-sm btn-secondary"
                        data-html2canvas-ignore="true"
                        @click="
                          descargarAdjunto2(d.idAdjunto, d.tipo, d.nombre)
                        "
                      >
                        <i class="bi bi-download"></i>
                      </button>

                      &nbsp;
                      {{ mostrar(d.nombre) }}
                    </td>
                    <td scope="row" data-label="Tipo">
                      {{ mostrar(d.tipo) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      hide-footer
      id="VisualizarDocumentoModal"
      size="lg"
      :title="tituloModalRespuesta"
    >
      <VisualizarDocumento
        :documento="documentoRespuesta"
        :buzon="buzon"
        @closeModal="cerrarModalVistaDoc"
      />
    </b-modal>

    <b-modal hide-footer id="EtiquetasModal" size="md">
      <template #modal-title>
        <div class="d-flex align-items-center">
          <button
            v-if="vista === 'abm'"
            class="btn btn-link me-2 p-0"
            @click="cambiarVista('lista')"
            style="text-decoration: none"
          >
            <i class="bi bi-chevron-compact-left"></i>
          </button>
          <button
            v-if="vista === 'lista'"
            class="btn btn-link me-2 p-0"
            @click="cambiarVista('home')"
            style="text-decoration: none"
          >
            <i class="bi bi-chevron-compact-left"></i>
          </button>
          <span>{{ tituloModalEtiquetas }}</span>
        </div>
      </template>
      <TagsComponent
        :vista.sync="vista"
        @closeModal="cerrarModalEtiquetas"
        :ticket="ticket"
        :etiquetasDoc="etiquetasLocal"
        @update:title="updateModalTitle"
        @update-etiquetas="actualizarEtiquetas"
      />
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
moment.locale("es");
import VisualizarDocumento from "./VisualizarDocumento.vue";
import TagsComponent from "./TagsComponent.vue";
import html2pdf from "html2pdf.js";

export default {
  name: "VisualizarDocumento",
  components: {
    TagsComponent,
    VisualizarDocumento,
  },
  props: {
    ticket: Object,
    buzon: String,
    etiquetasDoc: Array,
  },

  data() {
    return {
      validacionBFA: null,
      documentoRespuesta: null,
      tituloModalRespuesta: null,
      documento: null,
      cargandoAdjuntos: false,
      isAdjuntosOpen: false,
      exportacionPdf: false,
      descargandoDocumento: false,
      descargandoDetalle: false,
      estadoConfirmacionDescripciones: {
        ENVIADO_ENPROCESO: "En proceso de envío",
        ENVIADO_OK: "Entregado",
        DESTINO_RECIBIDO: "Descargado",
        DESTINO_PROCESADO: "Procesado",
      },
      estadoConfirmacionColores: {
        ENVIADO_ENPROCESO: "#d4a404",
        ENVIADO_OK: "#397120",
        DESTINO_RECIBIDO: "#28a745",
        DESTINO_PROCESADO: "#5FBD00",
      },
      vista: "home",
      tituloModalEtiquetas: "Etiquetas",
      etiquetasLocal: [...this.etiquetasDoc],
      showEtiquetas: this.$store.getters.futureEtiquetas,
    };
  },
  validations: {
    modelo: {
      organismoOrigen: {},
      dependenciaOrigen: {},
      dependenciaOrigenCodigo: {},
      organismoDestino: {},
      dependenciaDestino: {},
    },
  },
  computed: {
    fechaLeida() {
      if (!this.ticket.recibido) return "";

      return moment(this.ticket.recibido).format("D MMM [de] YYYY [a las] LT");
    },
    descripcionEstadoConfirmacion() {
      return (
        this.estadoConfirmacionDescripciones[this.ticket.estadoConfirmacion] ||
        null
      );
    },
    colorEstadoConfirmacion() {
      return (
        this.estadoConfirmacionColores[this.ticket.estadoConfirmacion] ||
        "#6c757d"
      );
    },
  },
  methods: {
    mostrar(valor) {
      return valor === null || valor === undefined ? "" : valor;
    },
    responder() {
      let docSeleccionado = this.ticket;

      if (docSeleccionado == undefined) {
        console.log("No se puede obtener el documento...");
      } else {
        this.$router.push({
          name: "EnviarDocumento",
          path: "/EnviarDocumento/",
          params: {
            guid: docSeleccionado.id,
            // nombre: docSeleccionado.documento.nombre,
            organismoOrigen:
              docSeleccionado.causaDestino.dependencia.codigoOrganismo,
            dependenciaOrigenCodigo:
              docSeleccionado.causaDestino.dependencia.codigoDependencia,
            dependenciaOrigen:
              docSeleccionado.causaDestino.dependencia.nombreDependencia,
            numeroOrigen: docSeleccionado.causaDestino.numero,
            caratulaOrigen: docSeleccionado.causaDestino.caratula,
            organismoDestino:
              docSeleccionado.causaOrigen.dependencia.codigoOrganismo,
            organismoDestinoNombre:
              docSeleccionado.causaOrigen.dependencia.nombreOrganismo,
            dependenciaDestino:
              docSeleccionado.causaOrigen.dependencia.codigoDependencia,
            dependenciaDestinoNombre:
              docSeleccionado.causaOrigen.dependencia.nombreDependencia,
            numeroDestino: docSeleccionado.causaOrigen.numero,
            caratulaDestino: docSeleccionado.causaOrigen.caratula,
          },
        });
      }
    },
    // descargarAxios(mUrl, fileName) {
    //   axios({
    //     url: mUrl,
    //     method: "GET",
    //     responseType: "blob",
    //   }).then((response) => {
    //     const href = URL.createObjectURL(response.data);

    //     const link = document.createElement("a");
    //     link.href = href;
    //     link.setAttribute("download", fileName);
    //     document.body.appendChild(link);
    //     link.click();

    //     document.body.removeChild(link);
    //     URL.revokeObjectURL(href);
    //   });
    // },
    async descargarAxios(mUrl, fileName) {
      const response = await axios({
        url: mUrl,
        method: "GET",
        responseType: "blob",
      });

      const href = URL.createObjectURL(response.data);

      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    },
    async validate(fileHash, rd) {
      const body = {
        file_hash: fileHash,
        rd: rd,
      };
      try {
        const response = await axios.post(
          "https://tsaapi.bfa.ar/api/tsa/verify/",
          body,
        );
        const data = response.data;
        if (data.status === "success") {
          data.messages = `El ticket fue sellado correctamente el ${data.attestation_time}`;
        }

        this.validacionBFA = data;
        return data;
      } catch (error) {
        this.validacionBFA = {
          status: "failure",
          messages: "El archivo no se encuentra registrado en la BFA",
        };
        console.error("Error during validation:", error, this.validacionBFA);
        throw error;
      }
    },
    // descargar() {
    //   const fileName = `Documento - ${this.ticket.id}.pdf`;

    //   this.descargarAxios(
    //     `/api/Documentos/${this.ticket.id}/descargar`,
    //     fileName,
    //   );
    // },
    async descargar() {
      try {
        this.descargandoDocumento = true;

        const fileName = `Documento - ${this.ticket.id}.pdf`;

        await this.descargarAxios(
          `/api/Documentos/${this.ticket.id}/descargar`,
          fileName,
        );
      } catch (error) {
        console.error("Error al descargar el documento:", error);
      } finally {
        this.descargandoDocumento = false;
      }
    },
    descargarAdjunto(id, tipo, nombre) {
      let docId = this.ticket.id;
      nombre;
      axios
        .get(`/api/Adjuntos/Link?IdDocumento=${docId}&Id=${id}&Tipo=${tipo}`)
        .then((response) => {
          var url = response.data.data.link;
          window.open(url, "_archivo");
        });
    },
    descargarAdjunto2(id, tipo, nombre) {
      let docId = this.ticket.id;
      this.descargarAxios(
        `/api/Adjuntos/Descargar?IdDocumento=${docId}&Id=${id}&Tipo=${tipo}`,
        `${nombre}`,
      );
    },
    // descargarPdfDetalle() {
    //   const acordeonIds = ["collapseBFA", "collapseTran", "collapseAdj"];
    //   const botonAcordeonSelectors = [
    //     '[data-bs-target="#collapseBFA"]',
    //     '[data-bs-target="#collapseTran"]',
    //     '[data-bs-target="#collapseAdj"]',
    //   ];

    //   acordeonIds.forEach((id) => {
    //     const el = document.getElementById(id);
    //     if (el && !el.classList.contains("show")) {
    //       el.classList.add("show");
    //     }
    //   });

    //   botonAcordeonSelectors.forEach((selector) => {
    //     const btn = document.querySelector(selector);
    //     if (btn && btn.classList.contains("collapsed")) {
    //       btn.classList.remove("collapsed");
    //     }
    //   });
    //   const id = this.ticket.id;
    //   const element = document.getElementById("impresionPdf");

    //   const opt = {
    //     margin: [18, 8],
    //     filename: `Constancia - ${id}.pdf`,
    //     html2canvas: { scale: 4 },
    //     jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    //   };

    //   html2pdf()
    //     .set(opt)
    //     .from(element)
    //     .toPdf()
    //     .get("pdf")
    //     .then(function (pdf) {
    //       pdf.text(`${id}`, 9, 12);
    //     })
    //     .save();
    // },
    async descargarPdfDetalle() {
      this.descargandoDetalle = true;

      try {
        const acordeonIds = ["collapseBFA", "collapseTran", "collapseAdj"];

        const botonAcordeonSelectors = [
          '[data-bs-target="#collapseBFA"]',
          '[data-bs-target="#collapseTran"]',
          '[data-bs-target="#collapseAdj"]',
        ];

        acordeonIds.forEach((id) => {
          const el = document.getElementById(id);

          if (el && !el.classList.contains("show")) {
            el.classList.add("show");
          }
        });

        botonAcordeonSelectors.forEach((selector) => {
          const btn = document.querySelector(selector);

          if (btn && btn.classList.contains("collapsed")) {
            btn.classList.remove("collapsed");
          }
        });

        const id = this.ticket.id;
        const element = document.getElementById("impresionPdf");

        const opt = {
          margin: [18, 8],
          filename: `Constancia - ${id}.pdf`,
          html2canvas: { scale: 4 },
          jsPDF: {
            unit: "mm",
            format: "a4",
            orientation: "portrait",
          },
        };

        await html2pdf()
          .set(opt)
          .from(element)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            pdf.text(`${id}`, 9, 12);
          })
          .save();
      } catch (error) {
        console.error("Error al generar el detalle:", error);
      } finally {
        this.descargandoDetalle = false;
      }
    },
    formatear(fecha) {
      if (!fecha) return "";

      let f = moment(fecha).format("DD/MM/YYYY");
      return f;
    },
    capitalize(texto) {
      if (!texto) return "";
      return texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase();
    },
    timeStamp(fecha) {
      if (!fecha) return "";

      let m = moment(fecha);
      let f = m.format("DD/MM/YYYY LT");
      return f;
    },
    toggleAdjuntos() {
      this.isAdjuntosOpen = !this.isAdjuntosOpen;

      if (this.isAdjuntosOpen) {
        this.$nextTick(() => {
          const acordeon = this.$refs.adjuntosAcordeon;
          if (acordeon) {
            acordeon.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        });
      }
    },
    actualizarEtiquetas(nuevasEtiquetas) {
      this.etiquetasLocal.splice(
        0,
        this.etiquetasLocal.length,
        ...nuevasEtiquetas,
      );
      this.$emit("update-etiquetas", this.etiquetasLocal);
    },
    handleAccordionClick() {
      this.isAdjuntosOpen = !this.isAdjuntosOpen;
    },
    agregarEtiqueta() {
      this.cambiarVista("home");
      this.$bvModal.show("EtiquetasModal");
    },
    cerrarModalEtiquetas() {
      this.$bvModal.hide("EtiquetasModal");
      this.cambiarVista("home");
    },
    cerrarModalVistaDoc() {
      this.$bvModal.hide("VisualizarDocumentoModal");
    },
    cambiarVista(vista) {
      this.vista = vista;
      this.tituloModalEtiquetas =
        vista === "lista" || vista === "home" ? "Etiquetas" : "Crear Etiqueta";
    },
    updateModalTitle(newTitle) {
      this.tituloModalEtiquetas = newTitle;
    },
  },
  watch: {
    ticket: {
      immediate: true,
      deep: true,
      handler() {
        if (this.ticket.tipoEnvio == "CON_ADJUNTOS") {
          this.cargandoAdjuntos = true;
          this.documento = null;

          axios
            .get(`/api/Documentos/${this.ticket.id}`)
            .then((response) => {
              this.documento = response.data;
            })
            .catch((error) => {
              console.error("Error al cargar los adjuntos:", error);
            })
            .finally(() => {
              this.cargandoAdjuntos = false;
            });
        } else {
          this.documento = null;
          this.cargandoAdjuntos = false;
        }
      },
    },
    etiquetasDoc: {
      immediate: true,
      deep: true,
      handler(nuevasEtiquetas) {
        this.etiquetasLocal = [...nuevasEtiquetas];
      },
    },
  },
};
</script>

<style>
.msgRechazado {
  font-size: 12px;
  font-style: oblique;
  color: #dc3545;
}

.spacing {
  margin-bottom: 0.2em;
}

#EtiquetasModal .modal-content {
  width: 80% !important;
}
</style>
